import { useEffect, useRef, useState } from 'react';

const prefersReducedMotion = () =>
  window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;

const easeOutCubic = t => 1 - (1 - t) ** 3;

export const useCountUp = (target, duration = 700) => {
  const [value, setValue] = useState(target);
  const fromRef = useRef(0);
  const frameRef = useRef();

  useEffect(() => {
    const to = Number(target) || 0;
    const from = fromRef.current;
    if (prefersReducedMotion() || from === to) {
      fromRef.current = to;
      setValue(to);
      return undefined;
    }
    const start = performance.now();
    const tick = now => {
      const progress = Math.min(1, (now - start) / duration);
      const current = from + (to - from) * easeOutCubic(progress);
      setValue(current);
      if (progress < 1) {
        frameRef.current = requestAnimationFrame(tick);
      } else {
        fromRef.current = to;
      }
    };
    frameRef.current = requestAnimationFrame(tick);
    return () => {
      cancelAnimationFrame(frameRef.current);
      fromRef.current = to;
    };
  }, [target, duration]);

  return value;
};

export const CountUp = ({ value, format = v => Math.round(v) }) => {
  const current = useCountUp(value);
  return <>{format(current)}</>;
};
